import classNames from 'classnames'
import {useSelector} from 'react-redux'
import {ImgButton} from '../../components/core/button'
import {PlusIcon, ServerEmptyContent} from '../../icons'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'
import Customer from '../../utils/customer'
import Tooltip from '../../components/core/tooltip'
import {envConfig} from '../../utils/env'

const {isReadOnlyModeEnabled} = envConfig

const EmptyContent = ({addServerResource}) => {
    const text = useNamespaceTranslations('server-monitoring')
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('empty-content-body server-monitoring', {
            dark: isDarkMode
        })}>
            <ServerEmptyContent/>
            <p>{text.content_empty}</p>
            {Customer.isOwnTeam() ?
                <ImgButton onClick={addServerResource} >
                    {text.add_server_monitoring}
                    <PlusIcon/>
                </ImgButton> :
                <Tooltip trigger='mouseenter' content={text.no_access} placement='top'>
                    <ImgButton onClick={addServerResource} disabled={!Customer.isOwnTeam() || isReadOnlyModeEnabled}>
                        {text.add_server_monitoring}
                        <PlusIcon/>
                    </ImgButton>
                </Tooltip>
            }
        </div>
    )
}
export default EmptyContent
